import React, { useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { Global } from "@emotion/react";
const AVIS_URL = Global.backend + "/index.php/avis/showall";
const DELETE_AVIS_URL = Global.backend + "/index.php/avis/delete";

const AdminAvisList = () => {
  var height = window.innerHeight;
  var width = window.innerWidth;
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [playOnce, setPlayOnce] = useState(false);
  const [avis, setAvis] = useState([]);

  const AlertSupp = (avisId) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success ml-3",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Êtes-vous sûr?",
        text: "Vous ne pourrez pas récupérer ce avis!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprimez-le!",
        cancelButtonText: "Non, annulez!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          fetchdeleteAvis(avisId);
          swalWithBootstrapButtons.fire(
            "Deleted!",
            "Avis Deleted !",
            "success"
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            "Canceled",
            "Deletion has been canceled :)",
            "error"
          );
        }
      });
  };

  function fetchAvis() {
    axios
      .post(AVIS_URL)
      .then((response) => {
        setAvis(response.data.slice().reverse());
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (!playOnce) {
      fetchAvis();
      setPlayOnce(true);
    }
  }, [avis, playOnce]);

  function fetchdeleteAvis(avisId) {
    axios
      .post(DELETE_AVIS_URL, {
        avisId: avisId,
      })
      .then((response) => {
        setPlayOnce(false);
      });
  }

  function Avis({ itemsPerPage }) {
    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);
    useEffect(() => {
      if (!isLoading) {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;
        console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(avis.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(avis.length / itemsPerPage));
      }
    }, [itemOffset, itemsPerPage, isLoading]);

    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % avis.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };



    return (
      <div className="container-fluid">
        <div className="page-content-wrapper">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body pt-5">
                  {isLoading && (
                    <div
                      style={{ height: height - 100 }}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <CircularProgress color="primary" size={80} />
                    </div>
                  )}
                  {!isLoading && (
                    <div className="table-responsive mt-3">
                      <table
                        className="table table-centered datatable dt-responsive nowrap "
                        style={{
                          borderCollapse: "collapse",
                          borderSpacing: "0",
                          width: "100%",
                        }}
                      >
                        <thead className="thead-light">
                          <tr>
                            <th>Nom du produit</th>
                            <th>Utilisateur</th>
                            <th>Entreprise</th>
                            <th> NB des étoiles</th>
                            <th>Avis</th>
                            <th style={{ width: 120 }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems != null &&
                            currentItems.map((av, index) => (
                              <tr key={index}>
                                <td>{av.produit.nom}</td>
                                <td>
                                  {av.user.prenom} {av.user.nom}
                                </td>
                                <td>{av.user.entreprise.nom}</td>

                                <td>{av.etoile_nb}</td>
                                <td>{av.commentaire}</td>
                                <td id="tooltip-container11">
                                  <a
                                    className="text-danger"
                                    title="Delete"
                                    onClick={() => AlertSupp(av.id)}
                                  >
                                    <i className="mdi mdi-trash-can font-size-18"></i>
                                  </a>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div className="container">
                        <ReactPaginate
                          className="pagination justify-content-center"
                          previousLabel={"<previous"}
                          nextLabel={"next>"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageClick}
                          containerClassName={"pagination"}
                          subContainerClassName={"pages pagination"}
                          activeClassName={"active"}
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          nextClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextLinkClassName={"page-link"}
                          disabledClassName={"disabled"}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
    setpageTitle("review")
    setalertTitle("")
    setnavLinks([])
  }, [])

  return (
    <Avis itemsPerPage={10} />

  );
};

export default AdminAvisList;
